import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { obtenrWalletPaqueteAction } from "../../../ducks/clientesDuck"
import { useEffect } from "react"
import FWallet from "./FWallet"
import ButtonDoload from "./ButtonDoload"
import ButtonDelete from "./ButtonDelete"
import { Alert } from "@material-ui/lab"

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});
const VDocumentos = () => {
  const { listaDocumentos, cliente, referencia } = useSelector(store => store.cliente)
  const classes = useStyles()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(obtenrWalletPaqueteAction({ idPaquete: cliente?.paquete?.Id_Paquete }))
  }, [dispatch, cliente?.paquete?.Id_Paquete])

  if (!referencia) return (
    <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
  )
  return (
    <div>
      <div style={{ padding: "20px 0", width: "100%", textAlign: "right" }}>
        <FWallet />
      </div>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Fecha de carga</TableCell>
              <TableCell align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listaDocumentos.map((row, index) => (
              <TableRow key={row.idCatDocumentoPaquete}>
                <TableCell align="center" component="th" scope="row">
                  {index + 1}
                </TableCell>
                <TableCell align="center">{`${row.Nombre}`}</TableCell>
                <TableCell align="center">{row?.FechaCarga.split("T")[0]}</TableCell>
                <TableCell align="center">
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ButtonDoload idDocumento={row.idCatDocumentoPaquete} Nombre={row.Nombre} />
                    <ButtonDelete
                      idDocumento={row.idCatDocumentoPaquete}
                      Nombre={row.Nombre}
                      idPaquete={cliente?.paquete?.Id_Paquete}
                    />
                    <FWallet
                      idDocumento={row.idCatDocumentoPaquete}
                      Nombre={row.Nombre}
                      update={true}
                    />
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
export default VDocumentos